import { converge, defaultTo, gt, path, pipe } from 'ramda';
import { getChargeAmount } from '../chargeAmount/selectors';

export const getGiftCard = pipe(
  path(['register', 'payment', 'giftCard', 'code']),
  defaultTo(''),
);

export const getGiftCardBalance = pipe(
  path(['register', 'payment', 'giftCard', 'balance']),
  defaultTo(0),
);

export const getGiftCardBarberName = pipe(
  path(['register', 'payment', 'giftCard', 'barberName']),
  defaultTo(''),
);

export const getGiftCardBarberId = pipe(
  path(['register', 'payment', 'giftCard', 'barberId']),
  defaultTo(''),
);

export const getInsufficientFunds = converge(
  gt,
  [getChargeAmount, getGiftCardBalance]
);
